<template>
  <div id="app">
    <div
      class="main"
      :style="{
        'padding-bottom': mainPadding,
        'background-color': ' #ffffff !important',
        'font-size': fontSize,
      }"
    >
      <v-idle
        v-if="userInfoState != undefined"
        @idle="onIdle"
        :duration="7200"
        style="display: none;"
      />

      <modal-idle-vue></modal-idle-vue>

      <top-line-partial v-if="showLayout"></top-line-partial>
      <header-partial v-if="showLayout"></header-partial>

      <cookie-policy />
      <router-view />
      <footer-partial v-if="showLayout"></footer-partial>

      <login-modal></login-modal>

      <!--            <news-single-modal></news-single-modal>-->
      <!-- <div class="chat-sec">
                <div class="chat-content">
                    <div class="chat-btn-box d-none d-lg-block">
                        <a href="#" class="chat-btn">Поставите питање</a>
                    </div>
                    <div class="chat-btn-box-m d-block d-lg-none">
                        <a href="#" class="mob-chat-link">
                            <span class="icon-message-circle"></span>
                        </a>
                    </div>
                </div>
            </div> -->
      <div class="d-none d-lg-block">
        <button
          v-show="visible"
          @click="scrollToTop"
          class="btn btn-primary btn-to-top"
        >
          Иди на врх стране
        </button>
      </div>

      <div class="d-block d-lg-none">
        <button
          v-show="visible"
          @click="scrollToTop"
          class="left_back-to-top_btn btn btn-primary btn-to-top"
        >
          <span class="icon-chevrons-up"></span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
// import {  mutations } from "@/store";
import { mapActions } from "vuex";
import HeaderPartial from "@/partials/HeaderPartial.vue";
import TopLinePartial from "@/partials/TopLinePartial.vue";
import FooterPartial from "@/partials/FooterPartial.vue";
import LoginModal from "@/components/LoginModal.vue";
import ModalIdleVue from "@/components/ModalIdle.vue";
import { mapState } from "vuex";
import * as roleService from "./services/role-service";
import * as userService from "./services/user-service";
// import NewsSingleModal from '@/components/NewsSingleModal.vue';

import axios from "axios";

import CookiePolicy from "./partials/CookiePolicy.vue";

export default {
  name: "home",
  data() {
    return {
      news_modal_2: false,
      newsModalContent: null,
      baseApiUrl: window.env.VUE_APP_API_KCPROXY_DEV,
      mainPadding: "360px !important",
      visible: false,
    };
  },
  components: {
    HeaderPartial,
    TopLinePartial,
    FooterPartial,
    LoginModal,
    ModalIdleVue,
    CookiePolicy,
  },
  computed: {
    ...mapState(["userInfoState", "showLayout", "showModalIdle", "fontSize"]),
  },
  methods: {
    ...mapActions(["setUserInfo", "resetUserInfo", "setShowModalIdle"]),

    checkInitialLogoutState() {
      if (localStorage.getItem("logoutEvent")) {
        this.logout();
        localStorage.removeItem("logoutEvent");
      }
    },
    handleStorageChange(event) {
      if (event.key === "logoutEvent") {
        this.logout();
        localStorage.removeItem("logoutEvent");
      }
    },
    logout() {
      axios.post(this.baseApiUrl + "proxy/logout").then((response) => {
        console.log(response.data);
        window.location.href = "/";
        this.setUserInfo(null);
      });
    },
    beforeOpenNewsModal(event) {
      this.newsModalContent = event.params.modalContent;
      // console.log(event.params.modalContent);
    },
    updateMainPadding() {
      const list = [
        "ViewActPage",
        "ViewActPageWithEli",
        "MML_ViewActPage",
        "PP_ViewActPage",
        "SUPA_ViewActPage",
        "SLGLRS_ViewActPage",
        "SLGLRS_ViewActPageWithEli",
        "REGULATIONS_ViewActPage",
        "EliWrapperComponent",
        "RegPDFJSViewer",
        "PppPDFJSViewer",
        "SlglrsPDFJSViewer",
      ];
      const isChildComponentActive = this.$route.matched.some((route) =>
        list.includes(route.name)
      );

      const isMobileView = window.innerWidth < 992;

      this.mainPadding =
        isChildComponentActive || isMobileView
          ? "0 !important"
          : "360px !important";
    },
    onIdle() {
      axios.post(this.baseApiUrl + "proxy/logout");
      this.setShowModalIdle(true);
      this.$root.$emit("bv::show::modal", "idle-modal");
    },
    handleScroll() {
      this.visible = window.scrollY > 200; // pojavi se posle 200px
    },
    scrollToTop() {
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
  },
  created() {
    const channel = new BroadcastChannel("logout-channel");
    channel.addEventListener("message", (event) => {
      if (event.data === "logout") {
        this.logout();
      }
    });
    this.channel = channel;
  },
  mounted() {
    window.addEventListener("storage", this.handleStorageChange);
    this.checkInitialLogoutState();

    window.addEventListener("scroll", this.handleScroll);

    // const isMobileView =  window.innerWidth < 992;

    //   this.mainPadding = isMobileView
    //     ? "0 !important"
    //     : "360px !important";

    const vm = this;

    if (window.env.CHAT_ENABLE) {
      const chatUrl = window.env.CHAT_URL;
      const scriptElement = document.createElement("script");
      scriptElement.type = "text/javascript";
      scriptElement.id = window.env.CHAT_ID;
      scriptElement.defer = true;
      scriptElement.src = chatUrl;

      // Append the script element to the document's head
      document.body.appendChild(scriptElement);
    }

    axios
      .post(this.baseApiUrl + "proxy/info")
      .then(function(response) {
        // not logged in 204
        if (response.status === 204) {
          // not logged in;  204
          vm.resetUserInfo();
        } else {
          let userData = response.data;
          if (userData.roles.includes("INTERNAL_USER")) {
            userData.roles = [
              "**",
              "NP",
              "INTERNAL_USER",
              "SGARHSTARO",
              "PGARHSTARO",
              "REG",
              "PG2010",
              "NEWS",
              "WPP_ESZLJP_GUIDE",
              "WPP_KD",
              "LSD",
              "SP",
              "SLARHSTARO",
              "MUARHSTARO",
              "MUTG",
              "BGP",
            ];
          }
          vm.setUserInfo(userData);
          userService.setUser(userData);
          roleService.setUserRoles(userData.roles);
        }
      })
      .catch(function(error) {
        console.log(error);
      });

    this.updateMainPadding();
  },
  watch: {
    $route() {
      this.updateMainPadding();
    },
  },
  beforeDestroy() {
    this.channel.close();
    window.removeEventListener("storage", this.handleStorageChange);
  },
  beforeUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  },
};
</script>

<div id="header_box">
    <iframe src="/viewActHeader/mml.html" frameborder="0"></iframe>
</div>

<style>
html {
  padding: 0 !important;
}

::v-deep .vbt-table-tools {
  display: none;
}

::v-deep #livezilla_wm {
  top: -25px !important;
}

::v-deep .lz_chat_unselectable,
.lz_overlay_wm_button,
.NotPrintableArea,
.lz_overlay_wm_sh_act,
.lz_anim_slide_in {
  top: -25px !important;
}

::v-deep #lz_overlay_wm .lz_overlay_wm_sh_act {
  top: -25px !important;
}

::v-deep .lz_overlay_wm {
  bottom: 50px !important;
}

::v-deep #lz_overlay_wm {
  margin-bottom: 50px;
}

::v-deep .lz_overlay_wm {
  bottom: 50px !important;
}

::v-deep .at-share-dock.atss {
  position: relative !important;
}

.at-share-dock.atss {
  position: relative !important;
}

::v-deep .atss {
  position: relative !important;
}

/* .atss {
    position: relative!important;
} */
@media (max-width: 800px) {
  #news_modal_17832___BV_modal_title_ {
    font-size: 12px !important;
    text-align: center;
    font-weight: 600;
  }

  .modal-title {
    font-size: 12px !important;
    text-align: center;
    font-weight: 600;
  }

  .mb-2 .mb-md-0 {
    font-size: 12px !important;
    text-align: center;
    font-weight: 600;
  }
}

#lz_overlay_chat {
  margin: 0px 0px 0px 0px !important;
}
</style>
